import Login from "../components/Login";
import Navigation from "../components/Navigation";
import Dashboard from "../components/Dashboard";
import Issues from "../components/Issues";
import Issue from "../components/Issue";
import Jobs from "../components/Jobs";
import Job from "../components/Job";
import Sites from "../components/Sites";
import Site from "../components/Site";
import SiteConfItems from "../components/Admin/SiteConfItems";
import Subcontractors from "../components/Subcontractors";
import Subcontractor from "../components/Subcontractor";
import Franchises from "../components/Franchises";
import Franchise from "../components/Franchise";
import Reports from "../components/Reports";
import Categories from "../components/Admin/Categories";
import PriceList from "../components/Admin/PriceList";
import IssueStatuses from "../components/Admin/IssueStatuses";
import Insurances from "../components/Admin/Insurances";
import Tickets from "../components/Admin/Tickets";
import JobStatuses from "../components/Admin/JobStatuses";

import { login } from "./guards.js";


export default [
  {
    path: "/login",
    name: "login",
    component: Login,
    beforeEnter: login
  },
  {
    path: "/",
    component: Navigation,
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "/issues",
        name: "issues",
        component: Issues
      },
      {
        path: "/issues/:id",
        name: "issue",
        component: Issue
      },
      {
        path: "/jobs",
        name: "jobs",
        component: Jobs
      },
      {
        path: "/jobs/:id",
        name: "job",
        component: Job
      },
      {
        path: "/sites",
        name: "sites",
        component: Sites
      },
      {
        path: "/sites/:id",
        name: "site",
        component: Site
      },
      {
        path: "/subcontractors",
        name: "subcontractors",
        component: Subcontractors
      },
      {
        path: "/subcontractors/:id",
        name: "subcontractor",
        component: Subcontractor
      },
      {
        path: "/franchises",
        name: "franchises",
        component: Franchises
      },
      {
        path: "/reports",
        name: "reports",
        component: Reports
      },
      {
        path: "/franchises/:id",
        name: "franchise",
        component: Franchise
      },
      {
        path: "/admin/categories",
        name: "categories",
        component: Categories
      },
      {
        path: "/admin/issue_statuses",
        name: "issueStatuses",
        component: IssueStatuses
      },
      {
        path: "/admin/insurances",
        name: "insurances",
        component: Insurances
      },
      {
        path: "/admin/tickets",
        name: "tickets",
        component: Tickets
      },
      {
        path: "/admin/job_statuses",
        name: "jobStatuses",
        component: JobStatuses
      },
      {
        path: "/admin/price_list",
        name: "priceList",
        component: PriceList
      },
      {
        path: "/admin/items",
        name: "siteConfItems",
        component: SiteConfItems
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js